<template>
  <zm-button type="primary" round @click='goUser'>{{ ctaName }}</zm-button>
</template>
<script>
export default {
  props: {
    ctaName: String,
    isZp: Boolean,
  },
  methods: {
    goUser() {
      this.$tracking.buyInteraction('purchase confirmation', this.ctaName?.toLowerCase?.());
      let url = '/account/user';
      if (this.isZp) {
        url = '/pbx/page/telephone/phoneUsers#/users';
      }
      window.location.href = url;
    }
  }
}
</script>
